<template>
  <v-container class="py-0" fluid>
    <v-row :class="bgColor">
      <template v-for="info in endpointInfos">
        <v-col cols="6" sm="4" md="3" lg="2" xl="1" v-if="info.type=='LIGHT'" :key="info.id">
          <LightTile :device="pie" :info="info" :report="endpointReports[info.id]||{}" :config="endpointConfigs[info.id]||{}" @command="command" @setting="setting"></LightTile>
        </v-col>
        <v-col cols="6" sm="4" md="3" lg="2" xl="1" v-if="info.type=='FAN'" :key="info.id">
          <FanTile :device="pie" :info="info" :report="endpointReports[info.id]||{}" :config="endpointConfigs[info.id]||{}" @command="command" @setting="setting"></FanTile>
        </v-col>
        <v-col cols="6" sm="4" md="3" lg="2" xl="1" v-if="info.type=='TEMPERATURE'" :key="info.id">
          <TemperatureTile :device="pie" :info="info" :report="endpointReports[info.id]||{}" :config="endpointConfigs[info.id]||{}" :desiredUnit="temperatureUnit" @setting="setting"></TemperatureTile>
        </v-col>
        <v-col cols="6" sm="4" md="3" lg="2" xl="1" v-if="info.type=='HUMIDITY'" :key="info.id">
          <HumidityTile :device="pie" :info="info" :report="endpointReports[info.id]||{}" :config="endpointConfigs[info.id]||{}" @setting="setting"></HumidityTile>
        </v-col>
        <v-col cols="6" sm="4" md="3" lg="2" xl="1" v-if="info.type=='ILLUMINATION'" :key="info.id">
          <IlluminateTile :device="pie" :info="info" :report="endpointReports[info.id]||{}" :config="endpointConfigs[info.id]||{}" @setting="setting"></IlluminateTile>
        </v-col>
        <v-col cols="6" sm="4" md="3" lg="2" xl="1" v-if="info.type=='MOTION'" :key="info.id">
          <MotionTile :device="pie" :info="info" :report="endpointReports[info.id]||{}" :config="endpointConfigs[info.id]||{}" @setting="setting"></MotionTile>
        </v-col>
        <v-col cols="6" sm="4" md="3" lg="2" xl="1" v-if="info.type=='SMOKE'" :key="info.id">
          <SmokeTile :device="pie" :info="info" :report="endpointReports[info.id]||{}" :config="endpointConfigs[info.id]||{}" @setting="setting"></SmokeTile>
        </v-col>
        <v-col cols="6" sm="4" md="3" lg="2" xl="1" v-if="info.type=='CONCENTRATION'" :key="info.id">
          <ConcentrationTile :device="pie" :info="info" :report="endpointReports[info.id]||{}" :config="endpointConfigs[info.id]||{}" :material="(info.attributes||{}).material" @setting="setting">
          </ConcentrationTile>
        </v-col>
        <v-col cols="6" sm="4" md="3" lg="2" xl="1" v-if="info.type=='CURTAIN'" :key="info.id">
          <CurtainTile :device="pie" :info="info" :report="endpointReports[info.id]||{}" :config="endpointConfigs[info.id]||{}" @command="command" @setting="setting"></CurtainTile>
        </v-col>
        <v-col cols="6" sm="4" md="3" lg="2" xl="1" v-if="info.type=='SWITCH'" :key="info.id">
          <SwitchTile :device="pie" :info="info" :report="endpointReports[info.id]||{}" :config="endpointConfigs[info.id]||{}" @command="command" @setting="setting"></SwitchTile>
        </v-col>
        <v-col cols="6" sm="4" md="3" lg="2" xl="1" v-if="info.type=='BUTTON'" :key="info.id">
          <ButtonTile :device="pie" :info="info" :report="endpointReports[info.id]||{}" :config="endpointConfigs[info.id]||{}" @setting="setting"></ButtonTile>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import LightTile from '@/components/tile/LightTile'
import FanTile from '@/components/tile/FanTile'
import TemperatureTile from '@/components/tile/TemperatureTile'
import HumidityTile from '@/components/tile/HumidityTile'
import IlluminateTile from '@/components/tile/IlluminateTile'
import MotionTile from '@/components/tile/MotionTile'
import SmokeTile from '@/components/tile/SmokeTile'
import ConcentrationTile from '@/components/tile/ConcentrationTile'
import CurtainTile from '@/components/tile/CurtainTile'
import SwitchTile from '@/components/tile/SwitchTile'
import ButtonTile from '@/components/tile/ButtonTile'

export default {
  name: 'PanelDetailEndpoint',
  components: {
    LightTile,
    FanTile,
    TemperatureTile,
    HumidityTile,
    IlluminateTile,
    MotionTile,
    SmokeTile,
    ConcentrationTile,
    CurtainTile,
    SwitchTile,
    ButtonTile
  },
  props: {
    pie: {
      type: String
    },
    data: {
      type: Object
    },
    temperatureUnit: {
      type: String
    },
    bgColor: {
      type: String
    }
  },
  computed: {
    endpointInfos() {
      return this.data.info || [];
    },
    endpointReports() {
      return this.data.report || {};
    },
    endpointConfigs() {
      return this.data.config || {};
    }
  },
  methods: {
    command(cmd) {
      this.$emit('command', cmd);
    },
    setting(infoId) {
      this.$emit('setting', infoId);
    }
  }
}
</script>